import { type RefObject, useEffect, useRef } from 'react'

import {
  type MapLane,
  monthHolding,
} from '@/modules/projects/components/Workbench/map'
import type { MapFilters } from '@/modules/projects/components/Workbench/mapView'

// Correcting the dates re-files the statement under the month it now closes in, which on a long
// map is far from where the user was looking. The map goes with it so nobody loses their place.
// A new pick of years redraws the whole map instead, so the map starts again from the top.
export const useMapFollows = (
  lanes: MapLane[],
  followStatementId: string | null,
  filters: MapFilters,
  scrollRef: RefObject<HTMLDivElement | null>,
) => {
  const openMonth = monthHolding(lanes, followStatementId)
  const filtersShown = useRef(filters)

  // biome-ignore lint/correctness/useExhaustiveDependencies: openMonth is the trigger; the chip moves cell while its id stays the same.
  useEffect(() => {
    const refiltered = filtersShown.current !== filters
    filtersShown.current = filters
    if (refiltered) {
      scrollRef.current?.scrollTo({ top: 0 })
      return
    }
    if (!followStatementId) return
    scrollRef.current
      ?.querySelector(`[data-statement-id="${followStatementId}"]`)
      ?.scrollIntoView({ block: 'nearest' })
  }, [followStatementId, openMonth, filters, scrollRef])
}
